module.exports = __webpack_public_path__ + "img/latitude-white-logo.1c416ab2.svg";